import React from 'react';
import { Dialog, DialogTitle, Button, DialogContent, DialogActions } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';

const PastDateAllocationDevice = props => {

    return (
    <Dialog
        className="custom-popup extend-device-popup scrollable-popup"
        PaperProps={{ classes: { root: 'custom-popup-root' } }}
        open={!!props.isOpen}
        onClose={props.onCancel}
        disableBackdropClick={true}
    >
        <div className="popup-wrap">
            <div className="popup-header">
                <DialogTitle className="popup-title"><IntlMessages id="main.deployed"></IntlMessages></DialogTitle>
                <div className="popup-header-right">
                    <Button className="popup-close" disableRipple={true} disableFocusRipple={true} onClick={props.onCancel}><i className="zmdi zmdi-close zmdi-hc-fw"></i></Button>
                </div>
            </div>
            <DialogContent className="popup-content deploy-success-content">
                <div className="field-group full-field-group">
                    <div className="field-group">
                        <IntlMessages id="popup.selectedDate"></IntlMessages>
                    </div>
                </div>
            </DialogContent>
            <DialogActions className="popup-footer">
                <Button className="primary-button" disableRipple={true} disableFocusRipple={true} onClick={props.onCancel} >Ok</Button>
            </DialogActions>
        </div>
    </Dialog>)
}

export default PastDateAllocationDevice;
